
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["violin-demo-common","violin-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Violin__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Violin/index.en.md?type=demo')
};